export default class AlertsActionsContentActionsController {
    constructor(EventEmitter, $timeout, ToastService, Loader) {
        this.eventEmitter = EventEmitter;
        this.$timeout = $timeout;
        this.ToastService = ToastService;
        this.Loader = Loader;
    }

    $onInit() {
        if (!this.actions) {
            this.actions = [];
        }
    }

    addNotification() {
        const notification = {
            id: Math.floor(Math.random() * 1000),
            type: 'notification',
            data: {
                users: null,
                email: null,
                message: null
            }
        };

        this.addAlert(notification);
    }

    addEmail() {
        const email = {
            id: Math.floor(Math.random() * 1000),
            type: 'email',
            data: {
                users: null,
                email: null,
                message: null
            }
        };

        this.addAlert(email);
    }

    addWebHook() {
        const webHook = {
            id: Math.floor(Math.random() * 1000),
            type: 'webhook',
            data: {
                users: null,
                email: null,
                message: null
            }
        };

        this.addAlert(webHook);
    }

    addAlert(action) {
        this.actions.push(action);
    }

    removeAction({ action }) {
        this.Loader.show();

        this.$timeout(() => {
            this.actions = this.actions.filter(item => item.id !== action.id);

            this.ToastService.show(this.ToastService.createSimple({
                text: 'Rule was deleted',
                position: 'bottom right'
            }));

            this.Loader.hide();
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/actions.controller.js